import React, { useState, useEffect } from 'react';

import './Stories.scss';
import PropTypes from 'prop-types';
import AvatarImage from '../AvatarImage/AvatarImage';

// This component will transition every transitionInterval s, if a user clicks, the transition is delayed to transitionInterval + 2s after their click and then continues transitioning

export default class Stories extends React.Component {
	constructor({ stories, transitionInterval, title }) {
		super();

		this.state = {
			stories: stories,
			currentVisible: 0,
			nextVisible: 1,
			nextTransition: new Date().getTime() + transitionInterval,
			title: title,
		};
		const clickTransition = transitionInterval + 2000;
		this.nextStory = nextStory.bind(this);
		this.nextStoryUser = nextStoryUser.bind(this);
		this.toStoryUser = toStoryUser.bind(this);
		this.transitionHandler = transitionHandler.bind(this);

		function nextStory() {
			if (this.state.stories.length === this.state.currentVisible + 1) {
				this.setState({
					currentVisible: 0,
					nextVisible: 1,
				});
			} else {
				this.setState(prevState => ({
					currentVisible: prevState.currentVisible + 1,
					nextVisible: prevState.nextVisible + 1,
				}));
			}
		}
		function toStoryUser(item) {
			const nextTransition = new Date().getTime() + transitionInterval;
			this.setState({
				currentVisible: item,
				nextVisible: this.state.stories.length === item + 1 ? 0 : item + 1,
				nextTransition,
			});
		}
		function nextStoryUser() {
			const nextTransition = new Date().getTime() + clickTransition;
			if (this.state.stories.length === this.state.currentVisible + 1) {
				this.setState({
					currentVisible: 0,
					nextVisible: 1,
					nextTransition,
				});
			} else {
				this.setState(prevState => ({
					currentVisible: prevState.currentVisible + 1,
					nextVisible: prevState.nextVisible + 1,
				}));
			}
		}
		function transitionHandler() {
			setInterval(() => {
				if (this.state.nextTransition <= new Date().getTime()) {
					this.setState({ nextTransition: new Date().getTime() + transitionInterval });
					this.nextStory();
				}
			}, 1000);
		}
		this.transitionHandler();
	}
	render() {
		return (
			<div className='stories-container'>
				{this.state.title !== undefined && (
					<div className='row title-container'>
						<h2>{this.state.title}</h2>
					</div>
				)}
				<div className='row'>
					<StoryItems
						stories={this.state.stories}
						currentVisible={this.state.currentVisible}
						nextVisible={this.state.nextVisible}
					/>
					<div className='stories-arrow-container col-md-2 col-lg-2 hide-on-sm'>
						<div className='stories-arrow' onClick={() => this.nextStoryUser()}>
							<i className='fa fa-chevron-right fa-4x'></i>
						</div>
					</div>
				</div>
				<div className='story-button-bar-container'>
					<div className='story-button-bar'>
						<StoryButtons
							stories={this.state.stories}
							currentVisible={this.state.currentVisible}
							toStoryUser={this.toStoryUser}
						/>
					</div>
				</div>
			</div>
		);
	}
}

Stories.propTypes = {
	stories: PropTypes.array.isRequired,
};

const StoryItems = props =>
	props.stories.map((story, i) => {
		if (story.position && story.quote && story.imageSrc) {
			return (
				<React.Fragment key={i}>
					<div
						className={`stories-avatar col-sm-12 col-md-4 story-item ${
							i === props.currentVisible ? 'active-story' : 'hidden-story'
						}`}
					>
						<AvatarImage imageSrc={story.imageSrc} size={200} />
					</div>
					<div
						className={`stories-content col-sm-12 col-md-6 story-item ${
							i === props.currentVisible ? 'active-story' : 'hidden-story'
						}`}
					>
						<div style={{ paddingTop: '10px' }}>
							<i className='fa fa-quote-left pink-quote'></i>
						</div>
						<p className='stories-quote'>{story.quote}</p>
						<p className='stories-position'>{`- ${story.position}`}</p>
					</div>
				</React.Fragment>
			);
		} else if (story.text && story.name && story.imageSrc) {
			return (
				<React.Fragment key={i}>
					<div
						className={`stories-avatar col-sm-12 col-md-4 story-item ${
							i === props.currentVisible ? 'active-story' : 'hidden-story'
						}`}
					>
						<AvatarImage imageSrc={story.imageSrc} size={200} />
					</div>
					<div
						className={`stories-content col-sm-12 col-md-6 story-item ${
							i === props.currentVisible ? 'active-story' : 'hidden-story'
						}`}
					>
						<h3 className='stories-title'>{story.name}'s Story</h3>
						<p className='stories-text'>{story.text}</p>
					</div>
				</React.Fragment>
			);
		} else {
			return null;
		}
	});

const StoryButtons = props =>
	props.stories.map((story, i) => (
		<div
			className={`story-button ${i === props.currentVisible ? 'active' : ''}`}
			key={'story-button-' + i}
			onClick={() => props.toStoryUser(i)}
		>
			<i className='fa fa-circle'></i>
		</div>
	));
